import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Skeleton, theme, Tooltip, Typography } from 'antd';
import { api } from '@shared/config/axiosConfig';
import { formatCurrency } from 'Utils/numberUtils';

const { Text } = Typography;

const QUOTATION_BALANCE_UPDATED_EVENT = 'QUOTATION_BALANCE_UPDATED';

export const QuotationBalance = () => {
  const { token } = theme.useToken();
  const pusher = useSelector((state) => state.utilities.pusher);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const receivedRealtimeBalance = useRef(false);

  useEffect(() => {
    let active = true;

    api.get('/api/marca_licencia/get_balance/')
      .then((response) => {
        if (!active || receivedRealtimeBalance.current) return;
        setBalance(response.data.saldo);
      })
      .catch(() => {
        if (!active || receivedRealtimeBalance.current) return;
        setBalance(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!pusher) return undefined;

    const onBalanceUpdated = (data) => {
      if (data?.saldo === undefined || data?.saldo === null) return;
      receivedRealtimeBalance.current = true;
      setBalance(data.saldo);
      setLoading(false);
    };

    pusher.bind(QUOTATION_BALANCE_UPDATED_EVENT, onBalanceUpdated);
    return () => {
      pusher.unbind(QUOTATION_BALANCE_UPDATED_EVENT, onBalanceUpdated);
    };
  }, [pusher]);

  if (loading) {
    return <Skeleton.Button active style={{ width: 148, height: token.controlHeight }} />;
  }

  if (balance === null || balance === undefined) return null;

  return (
    <Tooltip title='Saldo disponible para cotización'>
      <Flex
        align='center'
        gap={6}
        style={{
          height: token.controlHeight,
          paddingInline: 12,
          borderRadius: token.borderRadius,
          background: 'rgba(255, 255, 255, 0.16)',
          color: '#ffffff',
          cursor: 'default',
          maxWidth: '14em',
        }}
      >
        <Text strong style={{ color: 'inherit', whiteSpace: 'nowrap' }}>Saldo</Text>
        <Text ellipsis style={{ color: 'inherit' }}>{formatCurrency(balance)}</Text>
      </Flex>
    </Tooltip>
  );
};
